import React from 'react';
import classes from './GlobalLoader.module.scss';
import { Typography } from 'antd';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import ActivityIndicator from '../ActivityIndicator/ActivityIndicator';
import { getActivity } from 'shared/config/store/selectors/app';

const GlobalLoader = () => {
  const isActive = useSelector(getActivity);

  if (isActive) return (
    <div className={clsx(classes.container)}>
      <div className={classes.content}>
        <div className={classes.loaderContainer}>
          <ActivityIndicator fontSize={40} />
        </div>
        {/* {Boolean(message) && (
          <Typography.Text className={classes.message}>{message}</Typography.Text>
        )} */}
      </div>
    </div>
  )
  return null;
};
export default GlobalLoader;